/**
 * Job Favorite Validation Schema
 * Zod schemas for job favorite operations
 */

import { z } from "zod";

export const createJobFavoriteSchema = z.object({
  jobId: z.string().uuid(),
});

export const bulkJobFavoriteSchema = z.object({
  jobIds: z.array(z.string().uuid()).min(1),
});

export type CreateJobFavoriteInput = z.infer<typeof createJobFavoriteSchema>;
export type BulkJobFavoriteInput = z.infer<typeof bulkJobFavoriteSchema>;
